import { duration } from '@eturi/date-util'
import { landingSSO$, setSSO } from '../reducers/landing.slice'
import type { OPThunk } from '../types'

/** The server enforces SSO be valid for only 10 minutes. */
const SSO_VALIDITY_DURATION = duration(process.env.APP_ENV === 'dev' ? 3 : 9, 'm')

export const clearLandingSSOIfExpired = (): OPThunk => (dispatch, getState) => {
	const landingSSO = landingSSO$(getState())

	if (landingSSO && landingSSO.ts < Date.now() - SSO_VALIDITY_DURATION) {
		dispatch(setSSO(null))
	}
}
